export default {
  exports: null,
  exportData: null,
  resource: null,
  context: null, // organization or general
  loading: false,
};
